import React from "react";
import { app } from "./firebaseConfig";
import { useEffect, useState } from "react";
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut, User } from "firebase/auth";
import { getDoc, doc, getFirestore } from "firebase/firestore";

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export async function getUserData(uid: string) {
  try {
    const userDoc = await getDoc(doc(db, "users", uid));
    if (userDoc.exists()) {
      return userDoc.data(); // ユーザーデータを返す
    } else {
      console.log("No such document!");
      return null;
    }
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
}

export default function GoogleLogin() {
  const [user, setUser] = useState<User | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const uid = user.uid;
      const userData = await getUserData(uid);
      if (!userData) {
        fetch("https://bad-assort.com/api/new-user", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user?.uid
          }),
        })
          .then(response => response.json())
          .then(data => console.log("成功:", data))
          .catch(error => console.error("エラー:", error));
      }
    } catch (error) {
      console.error("ログインエラー:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setMenuOpen(false);
    } catch (error) {
      console.error("ログアウトエラー:", error);
    }
  };

  return (
    <div style={{ position: "absolute", top: 0, right: "20px", bottom: 0, display: "flex", alignItems: "center", flexDirection: "row-reverse" }}>
      {user ? (
        <div style={{ position: "relative" }}>
          <img
            src={user.photoURL || "https://via.placeholder.com/40"}
            alt="User Icon"
            style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
            onClick={() => setMenuOpen(!menuOpen)}
          />
          {menuOpen && (
            <div style={{ position: "absolute", top: "64px", right: "10px", background: "white", borderRadius: "5px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)", padding: "4px 10px", textWrap: "nowrap" }}>
              <p style={{ margin: "10px" }}>{user.displayName}</p>
              <button onClick={handleLogout} style={{ background: "none", border: "none", cursor: "pointer", boxShadow: "none", }}>ログアウト</button>
            </div>
          )}
        </div>
      ) : (
        <button onClick={handleLogin} style={{ padding: "5px 10px", background: "#f1f1f1", borderRadius: "5px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)", cursor: "pointer" }}>
          Googleでログイン
        </button>
      )}
    </div>
  );
}
